import {bindActionCreators} from 'redux'
import {closePanel, loadManagementAssignmentPanelDataAction} from '../actions'
import {connect} from '../../../../redux/utils'
import ManagementAssignmentsPanel from '../../managementAssignmentsPanel/ManagementAssignmentsPanel'
import {isLoading, isNeedToLoadData, isPanelOpened} from '../selectors'
import {isPanelOpened as isEditPanelOpened} from '../../../../panels/user/editPanel/selectors'
import ManagementAssignmentsPanelContent from './ManagementAssignmentsPanelContent'
import {setEventPreventHidingEditUserSlidingPanel} from '../../../../panels/utils'
import {closeAllPanels} from '../../common/actions'

class EditManagementAssignmentsPanel extends ManagementAssignmentsPanel {
    constructor(params) {
        const panelContent = new ManagementAssignmentsPanelContent({
            onBackButtonClick: () => this.params.onPanelHide(),
            onCloseButtonClick: () => params.closeAllPanels(),
            onClickDialogContent: (e) => setEventPreventHidingEditUserSlidingPanel(e),
        })
        super({
            ...params,
            additionalClass: 'editManagementAssignmentsPanel',
            panelContent: panelContent,
        })
    }
}

export default connect(
    state => ({
        userPanelOpenedBelow: isEditPanelOpened(state),
        needToLoadData: isNeedToLoadData(state),
        isShown: isPanelOpened(state),
        loading: isLoading(state),
    }),
    dispatch => ({
        loadData: bindActionCreators(loadManagementAssignmentPanelDataAction, dispatch),
        onPanelHide: bindActionCreators(closePanel, dispatch),
        closeAllPanels: bindActionCreators(closeAllPanels, dispatch),
    })
)(EditManagementAssignmentsPanel)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/editManagementAssignmentsPanel/components/ManagementAssignmentsPanel.js